module.exports = __webpack_public_path__ + "assets/cutlery-ee6629.svg";